import { render } from "./Research_en.vue?vue&type=template&id=38469018&scoped=true"
import script from "./Research_en.vue?vue&type=script&lang=js"
export * from "./Research_en.vue?vue&type=script&lang=js"

import "@/assets/css/globalen.css?vue&type=style&index=0&id=38469018&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38469018"]])

export default __exports__